export const deleteButton = 'delete';
export const successOptionUpdate = (optionName) => `Updated ${optionName}!`;
export const errorUpdatingOption = 'Error updating option!';
export const deleteOptionTitle = 'Are you sure you want to delete this option?';
export const deleteOptionDescription = 'This action is permanent.';
